
export const chatFlow = {
  start: {
    message: "Olá! 👋 Bem-vindo ao suporte da PapIA. Selecione a página onde você está com dúvidas:",
    options: [
      { label: "Gerenciar IA", next: "ia_help" },
      { label: "Perfil do Negócio", next: "business_profile_help" },
      { label: "Contatos", next: "registros_help" },
      { label: "Métricas", next: "analytics_help" },
      { label: "Conectar WhatsApp", next: "whatsapp_help" },
      { label: "Falar com Suporte Humano", action: "whatsapp_handoff" }
    ]
  },
  
  // --- Gerenciar IA ---
  ia_help: {
    message: "Na página de IA, você pode controlar o status da inteligência e configurar sua persona. O que você precisa?",
    options: [
      { label: "Como ativar/desativar?", next: "ia_status_help" },
      { label: "Configurar Persona", next: "ia_persona_help" },
      { label: "Gerenciar Cache", next: "cache_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  ia_status_help: {
    message: "Use o botão de 'Power' no topo da página para ligar ou desligar a IA. Quando ligada, ela responderá automaticamente aos seus clientes. O status é atualizado em tempo real.",
    options: [
      { label: "Entendi", next: "ia_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  ia_persona_help: {
    message: "Você pode definir o Nome, Descrição (quem ela é), Script de Recepção (primeira mensagem) e Imagem de perfil. Lembre-se de clicar em 'Salvar Alterações' após editar.",
    options: [
      { label: "Entendi", next: "ia_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  cache_help: {
    message: "O cache armazena respostas comuns para acelerar a interação. Se a IA não está enviando respostas esperadas, tente limpar o cache.",
    options: [
      { label: "Entendi", next: "ia_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  cache_clear_help: {
    message: "Clique em 'Limpar Cache' para remover respostas armazenadas. Isso pode resolver problemas de respostas incorretas.",
    options: [
      { label: "Entendi", next: "cache_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },

  // --- Perfil do Negócio ---
  business_profile_help: {
    message: "No Perfil do Negócio, você configura as informações essenciais que a IA usará para atender. Qual sua dúvida?",
    options: [
      { label: "Horários de Atendimento", next: "business_schedule_help" },
      { label: "Produtos e Serviços", next: "business_products_help" },
      { label: "Pagamento e Entrega", next: "business_operational_help" },
      { label: "Observações", next: "business_obs_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  business_schedule_help: {
    message: "Defina os dias e horários que sua empresa funciona. A IA usará isso para informar os clientes se você está aberto ou fechado no momento do contato.",
    options: [
      { label: "Entendi", next: "business_profile_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  business_products_help: {
    message: "Adicione seus produtos ou serviços com nome, descrição e preço. Isso permite que a IA informe os valores e tire dúvidas sobre o que você oferece.",
    options: [
      { label: "Entendi", next: "business_profile_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  business_operational_help: {
    message: "Configure métodos de pagamento aceitos (Pix, Cartão, etc.) e áreas de entrega. Essas informações são fundamentais para a IA informar os métodos de pagamento possíveis.",
    options: [
      { label: "Entendi", next: "business_profile_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  business_obs_help: {
    message: "Adicione observações adicionais sobre o seu negócio, como regras de negócio, políticas de cancelamento ou quaisquer outras informações que não sejam cobertas nas seções anteriores. Isso ajudará a aprimorar a interação com os clientes.",
    options: [
      { label: "Entendi", next: "business_profile_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },

  // --- Registros/Contatos ---
  registros_help: {
    message: "Em Registros, você gerencia sua base de contatos e histórico. O que deseja saber?",
    options: [
      { label: "Exportar Contatos", next: "registros_export_help" },
      { label: "Filtrar Lista", next: "registros_filter_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  registros_export_help: {
    message: "Use os botões de download no topo da lista para exportar seus contatos. Você pode baixar em CSV (para Excel) ou DOCX (para Word/PDF).",
    options: [
      { label: "Entendi", next: "registros_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  registros_filter_help: {
    message: "Use a barra de pesquisa para encontrar contatos rapidamente por nome ou telefone. A lista se atualiza automaticamente conforme você digita.",
    options: [
      { label: "Entendi", next: "registros_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },

  // --- Métricas/Analytics ---
  analytics_help: {
    message: "A página de Métricas mostra o desempenho do seu atendimento. Sobre o que você tem dúvida?",
    options: [
      { label: "Interações e Tempo", next: "analytics_general_help" },
      { label: "Gráficos", next: "analytics_charts_help" },
      { label: "Filtro de Data", next: "analytics_date_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  analytics_general_help: {
    message: "Veja o total de interações (mensagens), o tempo médio de resposta da IA e quantas vezes um humano precisou intervir no atendimento.",
    options: [
      { label: "Entendi", next: "analytics_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  analytics_charts_help: {
    message: "O gráfico de barras visualiza o volume de atendimentos e intervenções por dia. Passe o mouse sobre as barras para ver os números exatos.",
    options: [
      { label: "Entendi", next: "analytics_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },
  analytics_date_help: {
    message: "Use os seletores de data no topo para filtrar as métricas por um período específico. Por padrão, mostramos os dados dos últimos 7 dias.",
    options: [
      { label: "Entendi", next: "analytics_help" },
      { label: "Voltar ao início", next: "start" }
    ]
  },

  // --- Conectar WhatsApp ---
  whatsapp_help: {
    message: "A página 'Conectar WhatsApp' gerencia a ligação do seu número com a IA. Com o que posso ajudar?",
    options: [
      { label: "QR Code não aparece", next: "qr_code_issues" },
      { label: "Status incorreto", next: "connection_status_help" },
      { label: "Como reiniciar/excluir?", next: "reset_instance_help" },
      { label: "Voltar", next: "start" }
    ]
  },
  qr_code_issues: {
    message: "Se o QR Code não carrega:\n1. Verifique se não há bloqueadores de anúncio.\n2. Aguarde até 10s (o sistema tenta obter automaticamente).\n3. Se persistir, exclua a instância e crie novamente.",
    options: [
      { label: "Vou tentar recriar", next: "end_success" },
      { label: "Continua sem aparecer", action: "whatsapp_handoff" },
      { label: "Voltar", next: "whatsapp_help" }
    ]
  },
  connection_status_help: {
    message: "O status pode levar alguns segundos para atualizar (cache de 5s). Se diz 'Conectado' mas não envia, ou 'Desconectado' mas você escaneou:\n1. Use o botão 'Atualizar' (ícone de setas).\n2. Verifique se o celular tem internet.",
    options: [
      { label: "Entendi", next: "end_success" },
      { label: "Ainda com problemas", action: "whatsapp_handoff" },
      { label: "Voltar", next: "whatsapp_help" }
    ]
  },
  reset_instance_help: {
    message: "O ícone de 'Lixeira' serve para excluir a instância atual. Use isso quando:\n1. Trocar de número.\n2. Caso QR Code trave.\n3. O status ficar inconsistente.\nIsso desconecta o WhatsApp atual e gera um novo QR Code.",
    options: [
      { label: "Entendi", next: "end_success" },
      { label: "Preciso de ajuda", action: "whatsapp_handoff" },
      { label: "Voltar", next: "whatsapp_help" }
    ]
  },

  // --- Finalização ---
  end_success: {
    message: "Que ótimo que pude ajudar! Se precisar de mais alguma coisa, é só chamar. 👋",
    options: [
      { label: "Voltar ao início", next: "start" },
      { label: "Fechar chat", action: "close_chat" }
    ]
  }
};
